import { render, staticRenderFns } from "./formulario-examen-medico.vue?vue&type=template&id=ab6afd82&scoped=true"
import script from "./formulario-examen-medico.vue?vue&type=script&lang=js"
export * from "./formulario-examen-medico.vue?vue&type=script&lang=js"
import style0 from "./formulario-examen-medico.vue?vue&type=style&index=0&id=ab6afd82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6afd82",
  null
  
)

export default component.exports